import {Box} from '@mui/material';
import CollectionSelection from './CollectionSelection.tsx';
import ConfigurationSelection from './ConfigurationSelection.tsx';
import Highlights from './Highlights.tsx';
import VisualizeButton from './VisualizeButton.tsx';
import dimensions from '@src/styles/dimensions.ts';

export const Browse = () => {
  return (
    <>
      <ConfigurationSelection />
      <Box
        sx={{
          flexGrow: 1,
          overflowBlock: 'auto',
          display: 'flex',
          flexDirection: 'column',
          marginInline: `-${dimensions.leftSidebar.contentMargin}px`,
        }}
      >
        <CollectionSelection />
        <VisualizeButton />
        <Highlights />
      </Box>
    </>
  );
};

export default Browse;
